import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Briefcase, Mail, LogOut, Key, Phone } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';
import { authAPI } from '../../services/api';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        await authAPI.logout(refreshToken);
      }
    } catch (error) {
      // Continue with logout even if API call fails
    }
    
    authAPI.clearAuth();
    toast({
      title: "Logged out",
      description: "You have been successfully logged out"
    });
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/about', icon: FileText, label: 'About' },
    { path: '/admin/portfolio', icon: Briefcase, label: 'Portfolio' },
    { path: '/admin/messages', icon: Mail, label: 'Messages' },
    { path: '/admin/contact-info', icon: Phone, label: 'Contact Info' },
    { path: '/admin/settings', icon: Key, label: 'Security' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-black">
      <div className="flex">
        <aside className="w-64 min-h-screen border-r border-white/10 p-6 bg-black/50 backdrop-blur-sm">
          <Link to="/" className="flex items-center space-x-3 mb-12">
            <div className="relative w-6 h-6">
              <div className="absolute w-5 h-5 rounded-full bg-white" />
              <div className="absolute w-5 h-5 rounded-full bg-white left-2 mix-blend-exclusion" />
            </div>
            <span className="text-2xl font-light text-white">onlzCode</span>
          </Link>

          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-3 transition-all duration-300 ${
                    isActive(item.path)
                      ? 'bg-white/10 text-white border-l-2 border-white'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>

          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 px-4 py-3 text-gray-400 hover:text-white hover:bg-white/5 transition-all duration-300 mt-8 w-full"
          >
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </aside>

        <main className="flex-1 p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
